import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, Spinner, styled } from '@streem/ui-react';
export default function LostConnectionModal() {
    return (_jsxs(LostConnectionModalContainer, { children: [_jsx(SpinnerContainer, { children: _jsx(Spinner, {}) }), _jsx(MessageContainer, { children: _jsx(Header, { color: "white", size: "medium", style: { margin: 'auto' }, children: "You lost your network connection or are currently switching networks. Trying to reconnect." }) })] }));
}
const LostConnectionModalContainer = styled.div `
    text-align: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    padding: 30vh 0px;
    z-index: 50;
    background-color: rgba(18, 69, 111, 0.7);
    color: ${props => props.theme.text.color.white};
`;
const SpinnerContainer = styled.div `
    width: 100vw;
    padding: 16px;
`;
const MessageContainer = styled.div `
    padding: 40px;
`;
//# sourceMappingURL=lost_connection_modal.js.map